import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ErrorMessageComponent } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { FORM_FIELD_NAMES } from '../../models/constants/check-in-constants';
import { CheckInWidgetBaseComponent } from './check-in-widget-base.component';
@Component({
  selector: 'idp-check-in-widget',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ErrorMessageComponent],
  templateUrl: './check-in-widget.component.html',
  styleUrls: ['./check-in-widget.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CheckInWidgetComponent
  extends CheckInWidgetBaseComponent
  implements AfterViewInit, OnChanges, OnInit
{
  isTripByValueFocused = false;
  isLastNameFocused = false;
  isFromAirportFocused = false;

  ngOnInit() {
    this.initializeFreshComponent(this.content);
    this.setupFormSubscriptions(this.content);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setAirportSubject(changes);
    if (changes['resetErrorsTrigger']) {
      this.resetFormState();
    }
  }

  ngAfterViewInit(): void {
    this.dropDownCheckInOptions = this.dropdownService.initializeDropdown(
      this.content,
      this.checkInWidgetForm,
      (textData) => (this.checkInTextData = textData)
    );
  }

  openSearchModal(): void {
    this.checkInWidgetForm
      .get(FORM_FIELD_NAMES.ORIGIN_AIRPORT_CODE)
      ?.setValue(this.airportCode());
    this.openModalEmit.emit(true);
  }

  formSubmit(event: Event): void {
    if (!this.isIntentionalSubmit) {
      event.preventDefault();
      return;
    }
    this.setFlags();
    this.initService.processSubmission(
      this.formCheckIn,
      this.content,
      this.checkInTextData?.title,
      this.checkInWidgetForm?.valid
    );
  }

  focusFirstInvalidFieldHandler = (): void => {
    if (this.formCheckIn.findTripByValue.errors) {
      setTimeout(() => {
        const element = this.tripByValueInput?.nativeElement;
        this.setFocus(element);
      }, 0);
      return;
    }
    if (this.formCheckIn.lastName.errors) {
      setTimeout(() => {
        const element = this.lastNameInput?.nativeElement;
        this.setFocus(element);
      }, 0);
      return;
    }
    if (this.formCheckIn.originAirportCode.errors) {
      setTimeout(() => {
        this.openSearchModal();
      }, 0);
      return;
    }
  };
}
